module.exports = __webpack_public_path__ + "static/media/instagram.3388b1a1.svg";